@if (orderModel.orderErrorStates().orderWithInvalidTimeAttempted()) {
    <woa-footer-message [level]="MessageLevel.ERROR" [text]="orderModel.invalidOrderTimeMessage()"
                        [translationParams]="{storeName: orderingContextModel.currentStore()?.collectiveStoreName}"
                        [closable]="true"
                        (onClose)="orderModel.orderErrorStates().orderWithInvalidTimeAttempted.set(false)"></woa-footer-message>
}
@if (orderModel.orderErrorStates().tableOrderWithTimeAttempted()) {
    <woa-footer-message [level]="MessageLevel.ERROR" [text]="'woa.message.order.tableOrderTimeUnused'"
                        [closable]="true"
                        (onClose)="orderModel.orderErrorStates().tableOrderWithTimeAttempted.set(false)"></woa-footer-message>
}
